export default {
  classRoomOwned: {
    id: '',
    inUseClassRoomQty: null,
    availableClassRoomQty: null,
    maxClassRoomQty: null,
    capacity: null,
    startDate: '',
    endDate: '',
    classRoomTypeId: '',
  },
  classRoomsOwned: [],
  availableClassRoomsOwned: [],
  processing: false,
  error: null,
  success: null,
}



